import { ButtonVariantClasses } from '../constants/ButtonVariantClasses'
import { ButtonIconPosition, ButtonVariants, TextPosition } from '../types/buttonTypes'

export const getDefaultClasses = ({
    textPosition,
    variant,
    contained,
    disabled,
    className,
}: {
    textPosition: TextPosition
    variant: ButtonVariants
    contained: boolean
    disabled?: boolean
    className?: string
}): string => {
    return [
        `button-component relative border inline-flex items-stretch rounded-default ${
            textPosition === TextPosition.CENTER ? 'justify-center' : ''
        }`,
        ButtonVariantClasses[variant],
        contained
            ? 'h-full px-2 text-sm density-md:px-2 density-md:text-base density-lg:px-3'
            : 'py-1 px-2 text-sm density-md:py-2 density-md:px-4 density-md:text-base density-lg:py-3 density-lg:px-6',
        disabled ? 'opacity-30 pointer-events-none' : '',
        className || '',
    ].join(' ')
}

export const getIconClasses = ({
    iconPosition,
    hasChildren,
    labelIsForScreenReadersOnly,
}: {
    iconPosition: ButtonIconPosition
    hasChildren: boolean
    labelIsForScreenReadersOnly: boolean
}): string => {
    return [
        '-my-1px', // Without this buttons will become 2px higher than normal...
        iconPosition === ButtonIconPosition.LEFT && hasChildren ? '-ml-2 mr-1' : '',
        iconPosition === ButtonIconPosition.RIGHT && hasChildren ? '-mr-2 ml-1 order-1' : '',
        !hasChildren || !!labelIsForScreenReadersOnly ? 'inline-flex -mx-1 density-md:-mx-2 density-lg:-mx-3' : '',
    ].join(' ')
}

export const getSpinnerClasses = (variant: ButtonVariants): string => {
    return [
        variant !== ButtonVariants.QUIET && 'contrast',
        'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
    ].join(' ')
}
